import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpErrorHandler } from '../../shared/http-error-handler';

import { MapsDashboardService } from '../../_services/maps-dashboard.service';

import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-dashboard',
  templateUrl: './maps_dashboard.component.html',
  styleUrls: ['./maps_dashboard.component.sass'],
})
export class MapsDashboardComponent implements OnInit {
  statistics: any = {};
  profile: Profile;

  constructor(private router: Router, private mapsDashboardService: MapsDashboardService, private httpErrorHandler: HttpErrorHandler) {}

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.getStatistics();
  }

  getStatistics() {
    this.mapsDashboardService.getStatistics().subscribe(
      (data) => {
        this.statistics = data;
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/maps/maps_dashboard/maps_dashboard.component.ts